export default __webpack_public_path__ + "b3ab9f4bf403d2bb45c802d0f815d988.png";